import React from "react";
import Icons from "components/icons";
import { Localize } from "components/service";
import {
    formatStaffAttendanceTime,
} from "../helpers/staff-attendance-api-helper";
import {
    getStaffAttendanceFailedCheckout,
    getStaffAttendanceSessions,
    getStaffAttendanceSessionStatus,
} from "../helpers/staff-attendance-session-helper";
import { getStaffScanLocation } from "../helpers/staff-scan-location-helper";


const getStatusIcon = (status) => {
    switch (status)
    {
        case "in_progress":
            return <Icons.StaffInProcess />;
        case "missed_checkout":
            return <Icons.StaffClock />;
        case "failed_checkout":
            return <Icons.StaffAttention />;
        case "completed":
            return <Icons.StaffLocationMap />;
        default:
            return null;
    }
};

const StaffAttendanceSessionDetailsField = ({ attendanceRow, onOpenLocation }) => {
    const sessions = getStaffAttendanceSessions(attendanceRow);
    const showSessionNumber = sessions.length > 1;

    return (
        <div className={ `staff-attendance-session-details${ showSessionNumber ? " staff-attendance-session-details--multiple" : "" }` }>
            { sessions.map((session, index) => {
                const status = getStaffAttendanceSessionStatus(session, attendanceRow.status);
                const failedCheckout = getStaffAttendanceFailedCheckout(session);
                const location = getStaffScanLocation(
                    failedCheckout?.lastAttempt,
                    attendanceRow.worker
                );
                const zoneRadius = status === "failed_checkout" ?
                    failedCheckout?.lastAttempt?.zone_radius :
                    session.zone_radius;
                const isInsideZone = session.location_status === "inside_zone";
                const hasNoLocation = session.location_status === "no_location";
                const hasZoneRadius = (
                    zoneRadius !== null &&
                    zoneRadius !== undefined &&
                    Number.isFinite(Number(zoneRadius)) &&
                    Number(zoneRadius) > 0
                );

                return (
                    <div
                        key={ session.id || `session-${ index }` }
                        className={ `row-grid no-gap staff-attendance-session staff-attendance-session--${ status }` }>
                        <span>
                            { showSessionNumber ?
                                <Localize number={ index + 1 }>STAFF_MANAGEMENT.Text_SessionNumber</Localize> :
                                <Localize>STAFF_MANAGEMENT.Text_Session</Localize>
                            }
                        </span>
                        <span className="staff-attendance-session__time">
                            { formatStaffAttendanceTime(session.check_in_at) }
                        </span>
                        <span className="d-flex align-items-center staff-attendance-session__arrow" aria-hidden="true">
                            <Icons.Arrow />
                        </span>
                        <span className="staff-attendance-session__time">
                            { formatStaffAttendanceTime(session.check_out_at) }
                        </span>

                        <span className="d-flex align-items-center staff-attendance-session__state-icon" aria-hidden="true">
                            { getStatusIcon(status) }
                        </span>

                        <span className="staff-attendance-session__state">
                            { status === "completed" && isInsideZone && hasZoneRadius &&
                                <Localize radius={ zoneRadius }>
                                    STAFF_MANAGEMENT.AttendanceDetails_AllScansInsideZone
                                </Localize>
                            }
                            { status === "completed" && isInsideZone && !hasZoneRadius &&
                                <Localize>
                                    STAFF_MANAGEMENT.AttendanceDetails_AllScansInsideZoneUnknownRadius
                                </Localize>
                            }
                            { status === "completed" && hasNoLocation &&
                                <Localize>STAFF_MANAGEMENT.Text_NoLocation</Localize>
                            }
                            { status === "completed" && !isInsideZone && !hasNoLocation && <>&mdash;</> }
                            { status === "in_progress" &&
                                <Localize>STAFF_MANAGEMENT.AttendanceStatus_InProgress</Localize>
                            }
                            { status === "missed_checkout" &&
                                <Localize>STAFF_MANAGEMENT.AttendanceStatus_MissedCheckout</Localize>
                            }
                            { status === "failed_checkout" &&
                                <Localize radius={ zoneRadius ?? "—" }>
                                    STAFF_MANAGEMENT.AttendanceDetails_CheckoutRejected
                                </Localize>
                            }
                            { status === "unknown" && <>&mdash;</> }
                        </span>

                        { status === "missed_checkout" &&
                            <span className="staff-attendance-session__note">
                                <Localize>STAFF_MANAGEMENT.AttendanceDetails_MissedCheckoutNote</Localize>
                            </span>
                        }

                        { status === "failed_checkout" && failedCheckout &&
                            <span className="staff-attendance-session__note">
                                <Localize
                                    count={ failedCheckout.attemptsCount ?? "—" }
                                    first={ formatStaffAttendanceTime(failedCheckout.firstAttemptAt) }
                                    last={ formatStaffAttendanceTime(failedCheckout.lastAttemptAt) }
                                    distance={ failedCheckout.lastDistanceFromZone ?? "—" }>
                                    STAFF_MANAGEMENT.AttendanceDetails_FailedCheckoutSummary
                                </Localize>
                            </span>
                        }

                        { status === "failed_checkout" &&
                            (location ?
                                <button
                                    type="button"
                                    className="btn-text-link btn-text-link--underline staff-attendance-session__map-link"
                                    onClick={ (event) => {
                                        event.stopPropagation();
                                        onOpenLocation?.(location);
                                    } }>
                                    <Localize>STAFF_MANAGEMENT.Action_ViewMap</Localize>
                                </button> :
                                <span className="staff-attendance-session__no-location">
                                    <Localize>STAFF_MANAGEMENT.Text_NoLocation</Localize>
                                </span>
                            )
                        }
                    </div>
                );
            }) }
        </div>
    );
};

export default StaffAttendanceSessionDetailsField;
